import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["image", "className", "forceRenderPreview", "fit", "style", "alt"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as t } from "react/jsx-runtime";
import e from "react";
import d from "./InternalSanityImage.js";
import { c as r } from "../clsx-OuTLNxxd.js";
import { i as f, g as _ } from "../utils-NCUO6j8v.js";
const S = "SanityImage-module_container__ySxNH",
  I = "SanityImage-module_image-fit-crop__o-Dba",
  u = "SanityImage-module_image-fit-original__6ypzx",
  a = {
    container: S,
    imageFitCrop: I,
    imageFitOriginal: u
  },
  F = (_ref, g) => {
    let {
        image: o = {},
        className: n,
        forceRenderPreview: m = !1,
        fit: i = "crop",
        style: l,
        alt: c
      } = _ref,
      s = _objectWithoutProperties(_ref, _excluded);
    const p = r({
      [a.imageFitCrop]: i == "crop",
      [a.imageFitOriginal]: i == "original"
    });
    if (!f(o)) return null;
    const y = _(c);
    return /* @__PURE__ */t("div", {
      ref: g,
      className: r([a.container, p, n]),
      style: l,
      children: /* @__PURE__ */t(d, _objectSpread(_objectSpread(_objectSpread({}, o), s), {}, {
        forceRenderPreview: m,
        alt: y,
        fit: i
      }))
    });
  },
  N = /* @__PURE__ */e.memo( /* @__PURE__ */e.forwardRef(F));
export { N as SanityImage };